import * as Sentry from '@sentry/react';

// Redux basics
import { createStore, compose, applyMiddleware } from 'redux'

// Async fetch
import thunk from 'redux-thunk'

// Offline
import { createOffline } from '@redux-offline/redux-offline';
import offlineConfig     from '@redux-offline/redux-offline/lib/defaults';

// Browser history
// import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux'
import { createBrowserHistory } from 'history'
import { routerMiddleware }     from 'connected-react-router'

// Import the root reducer
import rootReducer     from './mainReducer'

import { persistStorage } from './persistence'

// REDUX DEV TOOLS
let composeEnhancers
if (['development', 'staging', 'review'].includes(process.env.NODE_ENV)) {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 }) || compose
} else {
  composeEnhancers = compose
}

let initialState = {}

// Add Sentry to Redux
const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  // Optionally pass options
});

// History Router middleware
export const history = createBrowserHistory()
const reduxRouterMiddleware = routerMiddleware(history)

// redux-offline is used only for connectivity detection (state.offline.online) and
// persistence. Syncing is driven imperatively by the Synchronizer, not the offline
// outbox, so no action carries meta.offline and the queue/effect/discard hooks are
// intentionally left as the (inert) defaults.
const reduxOfflineConfiguration = {
  ...offlineConfig,
  persistOptions: {
    storage: persistStorage,
    // notifications: a persisted display:true would reopen the notifications
    // overlay on every app load, locking the user out of the app
    blacklist: ['modale', 'notices', 'sidemenu', 'filters', 'advancedFilters', 'notifications'],
  },
}

// Offline middleware init.
const {
  middleware: offlineMiddleware,
  enhanceReducer,
  enhanceStore
} = createOffline(reduxOfflineConfiguration);

// Setup middleware list
const middlewareList = [
  thunk,
  reduxRouterMiddleware,
]
const middleware = applyMiddleware(...middlewareList, offlineMiddleware);

// Setting up the store with our configuration
export const store = createStore(
  enhanceReducer(rootReducer(history)),
  initialState,
  composeEnhancers(enhanceStore, middleware, sentryReduxEnhancer)
)

// export const history = syncHistoryWithStore(history, store)
